export enum RoutingPath {
  Dashboard = 'dashboard',
  Login = 'login',
  Register = 'register',
  OrderList = 'orders',
  TwoFactorAuth = 'two-factor',
  NotFound = 'not-found',
  OrderDetails = 'order-details',
  OrderAdd = 'order-add',
  UserProfile = 'user-profile',
  Administration = 'administration',
  UserManagement = 'user-management',
  ResetPassword = 'reset-password',
  CreatePassword = 'create-password',
  CreateUser = 'create-user',
  TermsAndConditions = 'terms-and-conditions',
  Imprint = 'imprint',
  DataProtection = 'data-protection',
  LoginSSO = 'sso-login',
  SsoLogout = 'logout',
  AccountSettings = 'account-settings'
}
